import React, { createContext, useState, useEffect, useContext } from 'react';

import partie from '../_mock/partie';
import { addPartiaService, deletePartiaService, editPartiaService, fetchPartie } from './partieServices';
import { useAlert } from '../hooks/useAlert';
import { UserContext } from './userContext';

export const PartieContext = createContext();

export const PartieProvider = ({ children }) => {
  const [partie, setPartie] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { error: errorAlert, confirm, success } = useAlert();
  const { user } = useContext(UserContext);

  const addPartia = async (item) => {
    try {
      const newPartia = await addPartiaService(item);
      const id = newPartia?.data?.data?.id;
      setPartie((prev) => [{ id, ...item }, ...prev]);
      success('Partia bola pridaná');
    } catch (err) {
      errorAlert('Nepodarilo sa pridať partiu.');
    }
  };

  const removePartia = async (id) => {
    const confirmation = await confirm('Prajete si vymazať partiu?', 'Vymazať');
    if (confirmation.isConfirmed) {
      try {
        const deletedPartia = await deletePartiaService(id);
        setPartie((prev) => prev.filter((item) => item.id !== id));
        success('Partia bola vymazaná');
      } catch (err) {
        errorAlert('Nepodarilo sa vymazať partiu.');
      }
    }
  };

  const getPartie = async () => {
    setLoading(true);
    try {
      const response = await fetchPartie();
      const data = await response.data;
      setLoading(false);
      setPartie(data);
    } catch (err) {
      setLoading(false);
      setError(err);
    }
  };

  const editPartia = async (clientId, editedPartia) => {
    try {
      const editPartia = await editPartiaService(clientId, editedPartia);
      setPartie((prev) =>
        prev.map((partia) => {
          if (partia.id === clientId) {
            return { ...partia, ...editedPartia };
          }
          return partia;
        })
      );
      success('Partia bola upravená');
    } catch (err) {
      errorAlert('Nepodarilo sa upraviť partiu.');
    }
  };

  useEffect(() => {
    getPartie();
  }, [user]);

  return (
    <PartieContext.Provider value={{ loading, partie, error, addPartia, removePartia, editPartia }}>
      {children}
    </PartieContext.Provider>
  );
};
